"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var _helpers = require("@qwkin/helpers");
var _reactDateRange = require("react-date-range");
var _theme = require("../utils/theme");
var _styledComponents = require("styled-components");
var _dateFns = require("date-fns");
var _excluded = ["children", "isRange", "key", "onChange", "theme", "maxDate", "minDate", "startDate", "endDate", "disabledDates", "onShownDateChange", "showPresets", "disabled"];
var DateRangePicker = function DateRangePicker(_ref) {
  var children = _ref.children,
    _ref$isRange = _ref.isRange,
    isRange = _ref$isRange === void 0 ? true : _ref$isRange,
    _ref$key = _ref.key,
    key = _ref$key === void 0 ? 'selection' : _ref$key,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? _helpers.identity : _ref$onChange,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    _ref$startDate = _ref.startDate,
    startDate = _ref$startDate === void 0 ? new Date() : _ref$startDate,
    _ref$endDate = _ref.endDate,
    endDate = _ref$endDate === void 0 ? new Date() : _ref$endDate,
    _ref$disabledDates = _ref.disabledDates,
    disabledDates = _ref$disabledDates === void 0 ? [] : _ref$disabledDates,
    onShownDateChange = _ref.onShownDateChange,
    _ref$showPresets = _ref.showPresets,
    showPresets = _ref$showPresets === void 0 ? true : _ref$showPresets,
    disabled = _ref.disabled,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: key
  };
  if (!isRange) {
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_reactDateRange.Calendar, (0, _extends2["default"])({
      disabled: disabled,
      date: startDate,
      onChange: _onChange,
      minDate: minDate,
      onShownDateChange: onShownDateChange,
      color: theme.color.primary["default"],
      disabledDates: disabledDates,
      rangeColors: [theme.color.primary["default"], theme.color.secondary["default"]]
    }, params)));
  }
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, showPresets ? /*#__PURE__*/_react["default"].createElement(_reactDateRange.DateRangePicker, (0, _extends2["default"])({
    disabled: disabled,
    ranges: [selectionRange],
    onShownDateChange: onShownDateChange,
    color: theme.color.primary["default"],
    disabledDates: disabledDates,
    rangeColors: [theme.color.primary["default"], theme.color.secondary["default"]],
    minDate: minDate,
    maxDate: maxDate,
    onChange: function onChange(dates) {
      _onChange([(0, _dateFns.startOfDay)(dates.selection.startDate), (0, _dateFns.endOfDay)(dates.selection.endDate)]);
    }
  }, params)) : /*#__PURE__*/_react["default"].createElement(_reactDateRange.DateRange, (0, _extends2["default"])({
    disabled: disabled,
    ranges: [selectionRange],
    onShownDateChange: onShownDateChange,
    color: theme.color.primary["default"],
    disabledDates: disabledDates,
    rangeColors: [theme.color.primary["default"], theme.color.secondary["default"]],
    minDate: minDate,
    maxDate: maxDate,
    onChange: function onChange(dates) {
      _onChange([(0, _dateFns.startOfDay)(dates.selection.startDate), (0, _dateFns.endOfDay)(dates.selection.endDate)]);
    }
  }, params)));
};
var _default = exports["default"] = DateRangePicker;